import { createRoot } from 'react-dom/client';

import { App } from './App';
import { AppEnvironment } from './AppEnvironment';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <AppEnvironment>
        <App />
    </AppEnvironment>
);
